/**
 * Check if the software version is supported based on a given year and month.
 * Software version is in the format of "product_year_month" or "product_year_month+patch" (e.g. S10_2021_04 or S10_2021_064)
 *
 * @param softwareVersion
 * @param supportedYear (e.g. '2011')
 * @param requiredSoftwareVersion The software-version required as 'yyyy.mm'-format (e.g. '2021.04' or '2021.064')
 */
export const isSoftwareVersionSupported = (requiredSoftwareVersion: string, softwareVersion?: string): boolean => {
  if (softwareVersion === undefined || requiredSoftwareVersion === 'none') return false

  const [, year, monthAndPatch] = softwareVersion.split('_')

  if (!year || !monthAndPatch) return false

  const softwareString = `${year}.${monthAndPatch}`

  if (Number(softwareString) < Number(requiredSoftwareVersion)) return false

  return true
}
